export const PROVIDER_BASIC_SCHEMA = [
  {
    elementConfig: {
      label: "Full Name",
      placeholder: "Full Name",
      type: "text",
    },
    elementType: "input",
    name: "name",
  },
  {
    elementConfig: {
      label: "Provider Type",
      placeholder: "Provider Type",
      type: "text",
    },
    elementType: "input",
    name: "provider_type",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "CP Credential",
      placeholder: "CP Credential",
      type: "email",
    },
    elementType: "input",
    name: "cp_credentials",
  },
  {
    elementConfig: {
      label: "NPI Number",
      placeholder: "NPI Number",
      type: "text",
    },
    elementType: "input",
    name: "npi_number",
  },
  {
    elementConfig: {
      label: "Practice",
      placeholder: "Practice",
      type: "text",
    },
    elementType: "input",
    name: "practice",
  },
];
